import { WebEnv } from '@easy-expense/env-mobile';
import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { devComeBackPrice, productionComeBackPrice } from '@easy-expense/utils-shared';
import React from 'react';

import { DripCheckout, PaddleCheckoutRef } from './DripCheckout.component';
import { OnboardingActionColumn, OnboardingBackdrop } from './OnboardingBackdrop.component';
import { Button } from '../Button.components';

export const ComeBack: React.FC<React.PropsWithChildren<{ email: string }>> = ({ email }) => {
  const checkoutRef = React.useRef<PaddleCheckoutRef>(null);

  const [isLoading, setIsLoading] = React.useState(false);

  const productID = WebEnv.buildType === 'production' ? productionComeBackPrice : devComeBackPrice;

  async function onCheckout() {
    setIsLoading(true);
    checkoutRef.current?.onCheckout();
    setIsLoading(false);
  }

  return (
    <OnboardingBackdrop>
      <OnboardingActionColumn>
        <Layout.Column grow>
          <OpenSans.Primary center weight="bold-700" size="3xl-38">
            {getTranslation('Upgrade now')}
          </OpenSans.Primary>

          <DripCheckout email={email} productID={productID} ref={checkoutRef} />

          <Spacer.Vertical size={24} />
          <Button.Primary px py radius center onClick={onCheckout} disabled={isLoading}>
            {getTranslation('Continue')}
          </Button.Primary>
        </Layout.Column>
      </OnboardingActionColumn>
    </OnboardingBackdrop>
  );
};
